import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import "@/index.css";

import Marketing from "@/pages/marketing/Marketing";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import Forgot from "@/pages/auth/Forgot";
import Reset from "@/pages/auth/Reset";

import CentralApp from "@/pages/central/CentralApp";
import StoreApp from "@/pages/store/StoreApp";
import StorefrontApp from "@/pages/storefront/StorefrontApp";

function AuthCallback() {
  const { exchangeGoogle } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const u = await exchangeGoogle(sid);
        window.history.replaceState({}, "", "/");
        navigate(u.tenant_id ? "/" : "/admin", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeGoogle, navigate]);
  return <div className="vp-dark min-h-screen grid place-items-center text-slate-400">Connexion en cours…</div>;
}

function Root() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Marketing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<Forgot />} />
      <Route path="/reset-password" element={<Reset />} />
      <Route path="/admin/*" element={<CentralApp />} />
      <Route path="/store/:slug/admin/*" element={<StoreApp />} />
      <Route path="/store/:slug/*" element={<StorefrontApp />} />
      <Route path="*" element={<Marketing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Root />
        <Toaster position="top-right" richColors theme="dark" />
      </BrowserRouter>
    </AuthProvider>
  );
}
